const IntBurdenDirective = {
  mounted(el, binding) {
    const input = el.tagName === 'INPUT' ? el : el.querySelector('input');
    if (!input) return;
    
    // 避免重复绑定
    if (el._integerHandler) return;

    const handleInput = (e) => {
      // 跳过中文输入法组合输入
      if (e.target.composing) return;
      
      const selectionStart = e.target.selectionStart;
      const originalValue = e.target.value;
      
      let newValue = originalValue.replace(/[^-0-9]/g, '');
      
      // 处理多个负号
      const minusCount = (newValue.match(/-/g) || []).length;
      if (minusCount > 1) {
        newValue = newValue.replace(/-/g, '');
        if (minusCount % 2 !== 0) {
          newValue = '-' + newValue;
        }
      }
      
      // 处理负号不在开头的情况
      if (newValue.includes('-') && newValue.indexOf('-') > 0) {
        newValue = newValue.replace(/-/g, '');
      }
      
      // 避免不必要的更新和循环
      if (newValue !== originalValue) {
        e.target.value = newValue;
        
        // 恢复光标位置
        const newCursorPos = Math.max(0, selectionStart - (originalValue.length - newValue.length));
        e.target.setSelectionRange(newCursorPos, newCursorPos);
        
        // 使用更安全的事件触发方式
        requestAnimationFrame(() => {
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
    };

    const handleBeforeInput = (e) => {
      // 在输入前进行预验证，减少不必要的处理
      if (e.data && !/[-0-9]/.test(e.data)) {
        e.preventDefault();
        return;
      }
    };

    const handleComposition = (e) => {
      if (e.type === 'compositionstart') {
        e.target.composing = true;
      }
      if (e.type === 'compositionend') {
        e.target.composing = false;
        // 触发一次输入验证
        const event = new Event('input', { bubbles: true });
        e.target.dispatchEvent(event);
      }
    };

    input.addEventListener('compositionstart', handleComposition);
    input.addEventListener('compositionend', handleComposition);
    input.addEventListener('beforeinput', handleBeforeInput);
    input.addEventListener('input', handleInput);
    
    // 保存引用以便卸载
    el._integerHandler = handleInput;
    el._beforeInputHandler = handleBeforeInput;
    el._compositionHandler = handleComposition;
  },
  
  unmounted(el) {
    const input = el.tagName === 'INPUT' ? el : el.querySelector('input');
    if (input) {
      if (el._integerHandler) {
        input.removeEventListener('input', el._integerHandler);
      }
      if (el._beforeInputHandler) {
        input.removeEventListener('beforeinput', el._beforeInputHandler);
      }
      if (el._compositionHandler) {
        input.removeEventListener('compositionstart', el._compositionHandler);
        input.removeEventListener('compositionend', el._compositionHandler);
      }
    }
  }
};

export default IntBurdenDirective;